<script lang="ts">
  import Button from '$components/elements/Button.svelte';
  import Heading from '$components/elements/Heading.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<div class="learn-more">
  <Heading textAlign="center">
    <Text key="page.homepage.learn-more.heading" />
  </Heading>
  <p>
    <Text key="page.homepage.learn-more.text" />
  </p>
  <Button icon="arrow-right" iconColor="#fff" href="/o-bibli21">
    <Text key="page.homepage.learn-more.button" />
  </Button>
</div>

<style lang="scss">
  .learn-more {
    max-width: 840px;
    width: 80%;
    margin: 98px auto 128px;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    p {
      font-size: 17px;
      line-height: 31px;
      font-weight: 500;
      text-align: center;
    }
  }
  @include mobile {
    .learn-more {
      gap: 16px;
      p {
        font-size: 16px;
        line-height: 31px;
      }
    }
  }
</style>
